import React from 'react';
import { Button } from '@chaser/components';
import { Link } from 'react-router-dom';

const RouterButton = props => {
  return <Button as={Link} {...props} />;
};

export default RouterButton;
